<xi-generic-modal
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="600px"
  (onClose)="cancel()"
>
  @if (isLoading) {
    <div class="loading">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  @if (!isLoading) {
    <div slot="children">
      <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
        <div slot="children">
          <div
            class="xi-modal__container embedding-options__container"
            *transloco="let t; read: 'embedding-options'"
          >
            <h2 class="xi-modal__title">{{ t('select-embedding-options') }}</h2>
            <div class="embedding-options__content">
              <div>
                <xi-dropdown
                  [data]="strategyDropDownData"
                  select="single"
                  label="{{ t('select-strategy') }}"
                  [(value)]="selectedStrategy"
                  [tooltip]="{ text: similarityToolTip }"
                ></xi-dropdown>
              </div>
              <div>
                <xi-dropdown
                  [placeholder]="t('select-model')"
                  [data]="modelDropDownData"
                  select="single"
                  label="{{ t('select-model') }}"
                  [tooltip]="{ text: breakdownToolTip }"
                  [(value)]="selectedModel"
                ></xi-dropdown>
              </div>
            </div>
            <div class="embedding-options__action">
              <div class="xi-loader-button-container">
                <xi-default-button
                  [text]="t('confirm')"
                  buttonSize="large"
                  [disabled]="isLoading"
                  (onClick)="confirm()"
                ></xi-default-button>
              </div>
            </div>
          </div>
        </div>
      </xi-basic-tile>
    </div>
  }
</xi-generic-modal>
